import React, { PropTypes } from 'react';
import { ReactSVG } from 'react-svg';

export default class Marker extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = { hovering: false };
	}

	getImageUrl() {
		if (this.props.point.hasImage) return '/mappin_camera.svg';
		return `/mappin_normal.svg`;
	}

	getColorClass() {
		switch ( this.props.point.type ) {
			case 3: // Custom Points
				return 'yellow';
			case 4: // Localities
				return 'blue';
			case 6: // Sampling Points
				return 'orange';	
			default:
				return 'red';
		}
	}

	renderLabel() {
		if (this.props.zoom <= 12) return;
		if (!this.props.point.label) return;

		const style = this.state.hovering ? {zIndex: 2} : {}; 

		return (
			<div className='pin-label' style={style}>
				<span>{this.props.point.label}</span>
			</div>
		);
	}

	onPinMouseEnter() {
		this.setState({hovering: true});
		
	}
	
	onPinMouseLeave() {
		this.setState({hovering: false});
	}

	render() {
		const imageUrl = this.getImageUrl();
		const color = this.getColorClass();
		return (
			<div>
				<ReactSVG 
					src={imageUrl}   
					beforeInjection={(svg) => {
						svg.classList.add(`pin-svg`);
						svg.classList.add(`${color}`);
					}}
					onClick={() => this.props.point.onClick()}
					onMouseEnter={() => this.onPinMouseEnter()}
					onMouseLeave={() => this.onPinMouseLeave()}
				/>
				{this.renderLabel()}
			</div>
		);
		
	}
}

Marker.propTypes = {
	point: PropTypes.object.isRequired,
	zoom: PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/Markers/Marker.js